// extracted by mini-css-extract-plugin
export default {"counter":"Counter_counter__pwNhI","value":"Counter_value__pZ7PY"};